//src/components/admin/UserForm.js
import React, { useState } from 'react';

const UserForm = ({ user = {}, initialData = {}, services, counters = [], kiosks = [], onSubmit, onCancel }) => {
  const [formData, setFormData] = useState({
    username: '',
    password: '',
    role: '',
    counter_id: '',
    kiosk_id: '',
    tenant_id: user?.tenant_id, // Auto-fill tenant_id from logged-in user, safe access
    ...initialData
  });

  const isEditMode = !!initialData?.id;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value === "" ? null : value // Convert empty strings to null for number fields
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(formData, isEditMode);
  };

  return (
    <form onSubmit={handleSubmit} className="admin-form">
      <div className="admin-form-group">
        <label>Username</label>
        <input type="text" name="username" value={formData.username} onChange={handleChange} required />
      </div>
      <div className="admin-form-group">
        <label>Password {!isEditMode && '(Required for new user)'}</label>
        <input type="password" name="password" value={formData.password} onChange={handleChange} required={!isEditMode} />
      </div>
      <div className="admin-form-group">
        <label>Role</label>
        <select name="role" value={formData.role} onChange={handleChange} required>
          <option value="">Select Role</option>
          <option value="operator">Operator</option>
          <option value="kiosk">Kiosk</option>
          <option value="admin">Admin</option>
          <option value="display">Display</option>
        </select>
      </div>
      {/* Conditional fields based on role */}
      {formData.role === 'operator' && (
        <div className="admin-form-group">
          <label>Assigned Counter</label>
          <select name="counter_id" value={formData.counter_id || ''} onChange={handleChange}>
            <option value="">None</option>
            {counters.filter(c => c.tenant_id === user?.tenant_id).map(c => (
              <option key={c.id} value={c.id}>{c.number}</option>
            ))}
          </select>
        </div>
      )}
      {formData.role === 'kiosk' && (
        <div className="admin-form-group">
          <label>Assigned Kiosk</label>
          <select name="kiosk_id" value={formData.kiosk_id || ''} onChange={handleChange}>
            <option value="">None</option>
            {kiosks.filter(k => k.tenant_id === user?.tenant_id).map(k => (
              <option key={k.id} value={k.id}>{k.name}</option>
            ))}
          </select>
        </div>
      )}

      <div className="admin-form-actions">
        <button type="submit" className="admin-button submit">{isEditMode ? 'Update User' : 'Add User'}</button>
        <button type="button" onClick={onCancel} className="admin-button cancel">Cancel</button>
      </div>
    </form>
  );
};

export default UserForm;